/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { CardLabelSelectView } from 'app/scripts/views/label/CardLabelSelectView';
import { CardMemberSelectView } from 'app/scripts/views/card/CardMemberSelectView';
import { CardMoveView } from 'app/scripts/views/card/CardMoveView';
import { CardViewHelpers } from './CardViewHelpers';
import { CardViewMixins } from './CardViewMixins';
import { DatePickerView } from 'app/scripts/views/card/DatePickerView';
import {
  getKey,
  Key,
  registerShortcutHandler,
  Scope,
  unregisterShortcutHandler,
} from '@trello/keybindings';
import { forTemplate } from '@trello/i18n';
import { LazyDateRangePicker } from 'app/src/components/DateRangePicker/LazyDateRangePicker';
import { defaultRouter } from 'app/src/router';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { StickerEditView } from 'app/scripts/views/stickers/StickerEditView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import { templates } from 'app/scripts/views/internal/templates';
import { seesVersionedVariation } from '@trello/feature-flag-client';
import { trackSeparator } from 'app/scripts/views/card/SeparatorCard/SeparatorCard';
import React from 'react';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { ConvertCardRoleButton } from 'app/src/components/QuickCardEditor';
import { renderDueComplete } from 'app/scripts/views/card/CardViewPlugins';
import { Urls } from 'app/scripts/controller/urls';
const { getCardUrl } = Urls;
import { toggleCardCoverChooserPopover } from 'app/scripts/views/card/CardCoverChooserPopover';

// TODO: Remove feature flag after successful deploy according to https://trello.com/c/VGE8H3ka/392-remove-feature-flag-for-copy-cards-date-tbd
import { CardCopyView } from 'app/scripts/views/card/CardCopyView';

const format = forTemplate('due_date_picker');

class QuickCardEditorView extends View {
  static initClass() {
    this.prototype.className = 'quick-card-editor';
    this.prototype.isMouseDownOnOverlay = false;

    this.prototype.renderDueComplete = renderDueComplete;

    this.prototype.events = {
      'keydown .js-edit-card-title': 'quickCardEditKeydown',
      'click .js-save-edits': 'saveEdits',

      'click .js-stop': 'stopCard',

      'click .js-edit-labels': 'editLabels',
      'click .js-edit-members': 'editMembers',
      'click .js-edit-cover': 'editCover',
      'click .js-move-card': 'moveCard',
      'click .js-copy-card': 'copyCard',
      'click .js-edit-due-date': 'editDueDate',
      'click .js-archive': 'archive',
      'click .js-due-date-badge': 'toggleDueDateComplete',

      click: 'checkCloseEditor',
      'click .js-close-editor': 'closeEditor',

      mousedown: 'mousedownOnOverlay',
    };
  }

  constructor(options) {
    super(options);
    this.onShortcut = this.onShortcut.bind(this);
    registerShortcutHandler(this.onShortcut, { scope: Scope.Overlay });
  }

  static open(cardView) {
    this.close();

    const { $el } = cardView;
    const offset = $el.offset();

    const opts = {
      width: $el.width(),
      left: offset.left,
      top: offset.top,
      onMap: cardView.onMap,
    };

    Analytics.sendScreenEvent({
      name: 'quickCardEditorInlineDialog',
      attributes: {
        view: getScreenFromUrl(),
      },
    });

    return (this.current = new QuickCardEditorView({
      model: cardView.model,
      modelCache: cardView.modelCache,
      onRemove: () => {
        this.current = null;
      },
    }).render(opts));
  }

  static close() {
    if (this.current != null) {
      this.current.closeEditor();
    }
    return (this.current = null);
  }

  initialize() {
    this.makeDebouncedMethods(
      'render',
      'renderStickers',
      'renderLabels',
      'renderCover',
      'renderBadges',
      'updateBadges',
      'rerender',
    );

    // We need to subscribe this onRouteChanged function to the router
    // so we would know when a user is navigating away from the page
    // where this was initialized. Otherwise the quick editor would
    // still be open regardless of the page the user navigates to.
    //
    // Specifically if they come to the board from the board list.
    // Without this subscription, after they hit the back button
    // the quick editor would sit on top of the board list page.
    this.unsubscribeFromRouter = defaultRouter.subscribe(
      this.onRouteChanged.bind(this),
    );
    this.routeWhenOpened = defaultRouter.getRoute().routePath;

    this.listenTo(this.model, {
      'change:labels': this.renderLabelsDebounced,
      'change:idLabels': this.renderLabelsDebounced,
      'change:idAttachmentCover': this.renderCoverDebounced,
      'change:cover': this.renderCoverDebounced,
      'change:dueComplete': this.renderDueComplete,
      'change:due change:subscribed change:isTemplate': this
        .renderBadgesDebounced,
      'change:badges': this.updateBadgesDebounced,
      'change:cardRole': this.rerenderDebounced,
    });

    this.listenTo(this.model.labelList, 'add remove reset change', () => {
      return this.renderLabelsDebounced();
    });

    this.listenTo(
      this.model.memberList,
      'add remove reset',
      this.frameDebounce(this.renderMembers),
    );

    return this.listenTo(
      this.model.stickerList,
      'add remove reset change sort',
      function () {
        return this.renderStickersDebounced();
      },
    );
  }

  onTracedUpdate(opts) {
    const { traceId, taskName, field } = opts;
    return (err, card) => {
      if (err) {
        throw Analytics.taskFailed({
          taskName,
          traceId,
          source: 'quickCardEditorInlineDialog',
          error: err,
        });
      } else {
        Analytics.sendUpdatedCardFieldEvent({
          field,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: card.id },
            board: { id: card.idBoard },
            list: { id: card.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
          attributes: {
            taskId: traceId,
          },
        });
        Analytics.taskSucceeded({
          taskName,
          traceId,
          source: 'quickCardEditorInlineDialog',
        });
      }
    };
  }

  shouldRenderFullCover() {
    return false;
  }

  onRouteChanged(routeContext) {
    // Backbone will fire this function once when the editor is opened
    // this conditional is here just to prevent the editor from instantly closing.
    if (routeContext.routePath !== this.routeWhenOpened) {
      return this.closeEditor();
    }
  }

  remove() {
    this.unsubscribeFromRouter();
    unregisterShortcutHandler(this.onShortcut);
    this.options.onRemove?.();
    return super.remove(...arguments);
  }

  showCover() {
    return this.model.getBoard().getPref('cardCovers') && this.model.hasCover();
  }

  showStickers() {
    return true;
  }

  onShortcut(event) {
    switch (getKey(event)) {
      case Key.Escape:
        this.closeEditor();
        Analytics.sendPressedShortcutEvent({
          shortcutName: 'closeEditorShortcut',
          keyValue: Key.Escape,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: this.model?.id },
            board: { id: this.model?.idBoard },
            list: { id: this.model?.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
        });
        return event.preventDefault();

      case Key.Enter:
        this.saveEdits();
        Analytics.sendPressedShortcutEvent({
          shortcutName: 'saveEditsShortcut',
          keyValue: Key.Enter,
          source: 'quickCardEditorInlineDialog',
          containers: {
            card: { id: this.model?.id },
            board: { id: this.model?.idBoard },
            list: { id: this.model?.idList },
            organization: { id: this.model?.getBoard()?.get('idOrganization') },
          },
        });
        return event.preventDefault();

      default:
        break;
    }
  }

  render(opts) {
    this.opts = opts;

    const data = this.model.toJSON();
    data.labels = this.model.getLabels();
    data.showCover = this.showCover();
    data.hasStickers = this.model.hasStickers();
    data.cardUrl = getCardUrl(this.model);
    data.quickEdit = true;
    data.members = [];
    data.isTemplate = this.model.isOnBoardTemplate();
    data.isCardTemplate = !!this.model.get('isTemplate');
    data.cardRole = this.model.getCardRole();

    // gotta position this thing
    data.left = this.cLeft = opts.left;
    data.top = this.cTop = opts.top;
    data.width = this.cWidth = opts.width;
    // 160 is the width of the controls, which are absolutely positioned
    const cRight = this.cWidth + this.cLeft + 160;
    const wWidth = $(window).width();

    // completely cover card on map
    if (opts.onMap) {
      data.top = data.top - 20;
    }

    if (cRight > wWidth) {
      data.leftButtons = true;
      this._usingLeftButtons = true;
    }

    this.$el.html(
      templates.fill(
        require('app/scripts/views/templates/quick_card_editor'),
        data,
        {},
      ),
    );

    this.renderStickers()
      .renderCover()
      .renderLabels()
      .renderBadges()
      .renderMembers()
      .checkShowCover();

    this.renderDueComplete();

    // view.remove() removes the editor from# the DOM, which happens every time
    // we close the editor, so this is okay.
    $('#chrome-container').append(this.$el);

    this.calcHeight();

    this.focusInput();

    this.defer(() => {
      return this.$('.quick-card-editor-buttons').addClass('fade-in');
    });

    this.$('.js-edit-card-title').autosize();

    renderComponent(
      React.createElement(ConvertCardRoleButton, {
        idCard: this.model.get('id'),
        onLoad: () => this.calcHeight(),
        analyticsContainers: this.model.getAnalyticsContainers(),
      }),
      this.$('#convert-card-role-button-react-root')[0],
    );

    return this;
  }

  rerender() {
    this.render(this.opts);
  }

  calcHeight() {
    let top;
    const wHeight = $(window).height();

    // Might overflow the window height so lets make sure that doesn't happen.
    // This needs to happen here because it's in the DOM now and the
    // calculations will be right.
    const cHeight = this.$('.quick-card-editor-card').outerHeight();
    if (this.cTop + cHeight > wHeight) {
      top = wHeight - cHeight - 8;
      this.$('.quick-card-editor-card').css({ top });
    }

    const $buttons = this.$('.quick-card-editor-buttons');
    const bHeight = $buttons.outerHeight();
    const bOffset = $buttons.offset();

    if (bHeight + bOffset.top > wHeight) {
      $buttons.css({ top: cHeight - bHeight });
    }
  }

  renderStickers() {
    // Don't re-render the stickers if we contain something that's in
    // the middle of an edit
    if (this.$('.sticker.moving, .sticker.rotating').length > 0) {
      return this;
    }

    const $stickers = this.$('.js-card-stickers').empty();
    const subviews = Array.from(this.model.stickerList.models).map((sticker) =>
      this.subview(StickerEditView, sticker, { card: this.model }),
    );
    this.appendSubviews(subviews, $stickers);

    this.$('.list-card').toggleClass('is-stickered', this.model.hasStickers());

    return this;
  }

  checkShowCover() {
    this.$('.list-card')
      .toggleClass('is-covered', this.showCover())
      .toggleClass('is-stickered', this.model.hasStickers());

    return this;
  }

  focusInput() {
    return this.$('.js-edit-card-title').focus().select();
  }

  showPopOver(e, viewClass, opts) {
    if (opts == null) {
      opts = {};
    }
    stopPropagationAndPreventDefault(e);

    PopOver.toggle({
      elem: $(e.target).closest('a'),
      view: new viewClass(
        _.extend({ model: this.model, modelCache: this.modelCache }, opts),
      ),
      alignRight: this._usingLeftButtons,
    });
  }

  showDateRangePicker(e) {
    const elem = this.$('.js-card-menu');
    if (elem) {
      return PopOver.toggle({
        elem: $(e.target).closest('a'),
        getViewTitle: () => format('dates'),
        keepEdits: true,
        reactElement: React.createElement(LazyDateRangePicker, {
          due: this.model.get('due'),
          start: this.model.get('start'),
          dueReminder: this.model.get('dueReminder'),
          hidePopover: () => PopOver.hide(),
          idCard: this.model.id,
          idBoard: this.model.getBoard()?.id,
          idOrg: this.model.getBoard()?.get('idOrganization'),
        }),
      });
    }
  }

  editLabels(e) {
    return this.showPopOver(e, CardLabelSelectView, {
      source: 'quickCardEditorInlineDialog',
    });
  }

  editMembers(e) {
    return this.showPopOver(e, CardMemberSelectView, {
      source: 'quickCardEditorInlineDialog',
    });
  }

  editCover(e) {
    toggleCardCoverChooserPopover({
      elem: this.$(e.currentTarget),
      cardId: this.model.id,
      traceSource: 'quickCardEditorInlineDialog',
    });
  }

  copyCard(e) {
    return this.showPopOver(e, CardCopyView, {
      onCopy: this.closeEditor.bind(this),
      source: 'quickCardEditorInlineDialog',
    });
  }

  editDueDate(e) {
    const seeDateRangePicker = seesVersionedVariation(
      'ecosystem.timeline-version',
      'stable',
    );

    if (seeDateRangePicker) {
      this.showDateRangePicker(e);
    } else {
      this.showPopOver(e, DatePickerView);
    }
  }

  moveCard(e) {
    const onCommit = this.closeEditor.bind(this);
    return this.showPopOver(e, CardMoveView, {
      onCommit,
      source: 'quickCardEditorInlineDialog',
    });
  }

  archive(e) {
    stopPropagationAndPreventDefault(e);

    const traceId = Analytics.startTask({
      taskName: 'edit-card/closed',
      source: 'quickCardEditorInlineDialog',
    });

    this.model.close(
      traceId,
      this.onTracedUpdate({
        traceId,
        taskName: 'edit-card/closed',
        field: 'closed',
      }),
    );

    this.closeEditor();

    Analytics.sendTrackEvent({
      action: 'archived',
      actionSubject: 'card',
      source: 'quickCardEditorInlineDialog',
      containers: {
        card: { id: this.model?.id },
        board: { id: this.model?.idBoard },
        list: { id: this.model?.idList },
        organization: { id: this.model?.getBoard()?.get('idOrganization') },
      },
    });
  }

  quickCardEditKeydown(e) {
    if (getKey(e) === Key.Enter) {
      return this.saveEdits(e);
    }
  }

  saveEdits(e) {
    stopPropagationAndPreventDefault(e);

    const val = this.$('.js-edit-card-title').val().trim();
    const currentVal = this.model.get('name');

    if (val === currentVal) {
      this.closeEditor();
    } else if (val !== '') {
      const traceId = Analytics.startTask({
        taskName: 'edit-card/name',
        source: 'quickCardEditorInlineDialog',
      });
      this.model.recordAction({
        type: 'rename',
        name: val,
        previousName: currentVal,
      });
      this.model.update(
        { name: val, traceId: traceId },
        this.onTracedUpdate({
          traceId,
          taskName: 'edit-card/name',
          field: 'name',
        }),
      );
      this.closeEditor();
      trackSeparator(val, {
        category: 'quick card editor',
        method: 'by editing name',
      });
    } else {
      this.$('.js-edit-card-title').focus().select();
    }
  }

  mousedownOnOverlay(e) {
    this.isMouseDownOnOverlay = e.target === this.$el[0];
  }

  checkCloseEditor(e) {
    if (this.isMouseDownOnOverlay) {
      this.isMouseDownOnOverlay = false;

      if (PopOver.isVisible) {
        PopOver.hide();
      } else if (this.$('.sticker.editing').length > 0) {
        this.stopEditingStickers();
      } else {
        this.closeEditor(e);
      }
    }
  }

  closeEditor(e) {
    this.remove();
    PopOver.hide();
    Analytics.sendClosedComponentEvent({
      componentName: 'quickCardEditorInlineDialog',
      componentType: 'inlineDialog',
      containers: {
        card: { id: this.model?.id },
        board: { id: this.model?.idBoard },
        list: { id: this.model?.idList },
        organization: { id: this.model?.getBoard()?.get('idOrganization') },
      },
      source: getScreenFromUrl(),
    });
  }

  stopEditingStickers() {
    for (const sticker of Array.from(_.clone(this.model.stickerList.models))) {
      sticker.trigger('stopEditing');
    }
  }

  stopCard(e) {
    e?.stopPropagation();
    PopOver.hide();
  }
}
QuickCardEditorView.initClass();

_.extend(QuickCardEditorView.prototype, CardViewMixins, CardViewHelpers);

export { QuickCardEditorView };
